import FormContainer from "../../../../components/formContainer/FormContainer";
import InputWrapper from "../../../../components/input/wrapper/InputWrapper";
import OverlayLoader from "../../../../components/loader/OverlayLoader/OverlayLoader";
import Select from "../../../../components/select/main/Select";
import { useLanguageContext } from "../../../../context/LanguageContext";
import EVAApiHelper from "../../../../helpers/EVAApiHelper";
import { StyledInput } from "../../../../styles/InputStyles";
import { StyledFlexColumn } from "../../../../styles/LayoutStyles";

function AccessCommander2NConfigPageView({
  onCancel,
  onSubmit,
  onApiTokenChange,
  onUrlChange,
  onUsernameChange,
  onPasswordChange,
  onCompanyNameChange,
  onGroupNameChange,
  onTypeChange,
  submitError,
  accessCommanderData,
}) {
  const { translate } = useLanguageContext();

  return (
    <OverlayLoader groups="access_commander_2n_config_page_fetch">
      <FormContainer
        onCancel={onCancel}
        onSubmit={onSubmit}
        submitError={submitError}
        submitLoadingGroup={"access_commander_2n_config_page_save"}
      >
        <StyledFlexColumn>
          <InputWrapper
            label={translate("eva.main.validation.attributes.type")}
            error={EVAApiHelper.getResponseError("type", submitError)}
          >
            <Select
              value={accessCommanderData?.type}
              options={[
                { value: "commander", label: "Access Commander" },
                { value: "qr", label: "QR Unit" },
              ]}
              onChange={onTypeChange}
              disabled={accessCommanderData.default}
            />
          </InputWrapper>

          <InputWrapper
            label={translate("eva.main.validation.attributes.api_token")}
            error={EVAApiHelper.getResponseError("api_token", submitError)}
          >
            <StyledInput
              type="text"
              placeholder={translate("eva.main.validation.attributes.api_token")}
              value={accessCommanderData?.api_token ?? ""}
              onChange={onApiTokenChange}
            />
          </InputWrapper>

          <InputWrapper
            label={translate("eva.main.validation.attributes.url")}
            error={EVAApiHelper.getResponseError("url", submitError)}
          >
            <StyledInput
              type="text"
              placeholder={translate("eva.main.validation.attributes.url")}
              value={accessCommanderData?.url ?? ""}
              onChange={onUrlChange}
            />
          </InputWrapper>

          <InputWrapper
            label={translate("eva.main.validation.attributes.username")}
            error={EVAApiHelper.getResponseError("username", submitError)}
          >
            <StyledInput
              type="text"
              placeholder={translate("eva.main.validation.attributes.username")}
              value={accessCommanderData?.username ?? ""}
              onChange={onUsernameChange}
            />
          </InputWrapper>
          
          <InputWrapper
            label={translate("eva.main.validation.attributes.password")}
            error={EVAApiHelper.getResponseError("password", submitError)}
          >
            <StyledInput
              type="text"
              placeholder={translate("eva.main.validation.attributes.password")}
              value={accessCommanderData?.password ?? ""}
              onChange={onPasswordChange}
            />
          </InputWrapper>

          <InputWrapper
            label={translate("eva.main.validation.attributes.company_name")}
            error={EVAApiHelper.getResponseError("company_name", submitError)}
          >
            <StyledInput
              type="text"
              placeholder={translate("eva.main.validation.attributes.company_name")}
              value={accessCommanderData?.company_name ?? ""}
              onChange={onCompanyNameChange}
            />
          </InputWrapper>

          <InputWrapper
            label={translate("eva.main.validation.attributes.group_name")}
            error={EVAApiHelper.getResponseError("group_name", submitError)}
          >
            <StyledInput
              type="text"
              placeholder={translate("eva.main.validation.attributes.group_name")}
              value={accessCommanderData?.group_name ?? ""}
              onChange={onGroupNameChange}
            />
          </InputWrapper>
        </StyledFlexColumn>
      </FormContainer>
    </OverlayLoader>
  );
}

export default AccessCommander2NConfigPageView;